!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?n(exports):"function"==typeof define&&define.amd?define(["exports"],n):n((t="undefined"!=typeof globalThis?globalThis:t||self).htmlToImage={})}(this,(function(t){"use strict";
function n(t,n,e,r){return new(e||(e=Promise))((function(o,i){function u(t){try{f(r.next(t))}catch(t){i(t)}}function c(t){try{f(r.throw(t))}catch(t){i(t)}}function f(t){var n;t.done?o(t.value):(n=t.value,n instanceof e?n:new e((function(t){t(n)}))).then(u,c)}f((r=r.apply(t,n||[])).next())}))}function e(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(e)throw new TypeError("Generator is already executing.");for(;u;)try{if(e=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=n.call(t,u)}catch(t){i=[6,t],r=0}finally{e=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}}var r="application/font-woff",o="image/jpeg",i={woff:r,woff2:r,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:o,jpeg:o,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml"};function u(t){var n=function(t){var n=/\.([^./]*?)$/g.exec(t);return n?n[1]:""}(t).toLowerCase();return i[n]||""}function c(t){return-1!==t.search(/^(data:)/)}function f(t,n){return"data:"+n+";base64,"+t}var a,s=(a=0,function(){return a+=1,"u"+("0000"+(Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)+a});function l(t){for(var n=[],e=0,r=t.length;e<r;e+=1)n.push(t[e]);return n}function h(t,n){var e=window.getComputedStyle(t).getPropertyValue(n);return parseFloat(e.replace("px",""))}function d(t){return t.toBlob?new Promise((function(n){return t.toBlob(n)})):new Promise((function(n){for(var e=window.atob(t.toDataURL().split(",")[1]),r=e.length,o=new Uint8Array(r),i=0;i<r;i+=1)o[i]=e.charCodeAt(i);n(new Blob([o],{type:"image/png"}))}))}function v(t){return new Promise((function(n,e){var r=new Image;r.onload=function(){return n(r)},r.onerror=e,r.crossOrigin="anonymous",r.decoding="sync",r.src=t}))}function p(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve().then((function(){return(new XMLSerializer).serializeToString(t)})).then(encodeURIComponent).then((function(t){return"data:image/svg+xml;charset=utf-8,"+t}))]}))}))}var g={};function m(t,n){var e=function(t){var n=t.replace(/\?.*/,"");return/ttf|otf|eot|woff2?/i.test(n)&&(n=n.replace(/.*\//,"")),n}(t);if(null!=g[e])return g[e];n.cacheBust&&(t+=(/\?/.test(t)?"&":"?")+(new Date).getTime());var r=window.fetch(t).then((function(t){return t.blob().then((function(n){return{blob:n,contentType:t.headers.get("Content-Type")||""}}))})).then((function(t){var n=t.blob,e=t.contentType;return new Promise((function(t,r){var o=new FileReader;o.onloadend=function(){return t({contentType:e,blob:o.result})},o.onerror=r,o.readAsDataURL(n)}))})).then((function(t){var n,e=t.blob;return{contentType:t.contentType,blob:(n=e,n.split(/,/)[1])}})).catch((function(e){var r="";if(n.imagePlaceholder){var o=n.imagePlaceholder.split(/,/);o&&o[1]&&(r=o[1])}var i="Failed to fetch resource: "+t;return e&&(i="string"==typeof e?e:e.message),i&&console.error(i),{blob:r,contentType:""}}));return g[e]=r,r}function w(t,n,e){var r="."+t+":"+n,o=e.cssText?function(t){var n=t.getPropertyValue("content");return t.cssText+" content: '"+n.replace(/'|"/g,"")+"';"}(e):function(t){return l(t).map((function(n){return n+": "+t.getPropertyValue(n)+(t.getPropertyPriority(n)?" !important":"")+";"})).join(" ")}(e);return document.createTextNode(r+"{"+o+"}")}function b(t,n,e){var r=window.getComputedStyle(t,e),o=r.getPropertyValue("content");if(""!==o&&"none"!==o){var i=s();try{n.className=n.className+" "+i}catch(t){return}var u=document.createElement("style");u.appendChild(w(i,e,r)),n.appendChild(u)}}function y(t){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return"data:,"===(n=t.toDataURL())?[2,Promise.resolve(t.cloneNode(!1))]:[2,v(n)]}))}))}function P(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve(t.poster).then((function(t){return m(t,r)})).then((function(n){return f(n.blob,u(t.poster)||n.contentType)})).then((function(t){return v(t)}))]}))}))}function S(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return r instanceof Element?[2,Promise.resolve().then((function(){return function(t,n){var e=window.getComputedStyle(t),r=n.style;r&&(e.cssText?r.cssText=e.cssText:l(e).forEach((function(t){r.setProperty(t,e.getPropertyValue(t),e.getPropertyPriority(t))})))}(t,r)})).then((function(){return function(t,n){b(t,n,":before"),b(t,n,":after")}(t,r)})).then((function(){return function(t,n){t instanceof HTMLTextAreaElement&&(n.innerHTML=t.value),t instanceof HTMLInputElement&&n.setAttribute("value",t.value)}(t,r)})).then((function(){return r}))]:[2,Promise.resolve(r)]}))}))}function x(t,r,o){return n(this,void 0,void 0,(function(){return e(this,(function(i){return o||!r.filter||r.filter(t)?[2,Promise.resolve(t).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return t instanceof HTMLCanvasElement?[2,y(t)]:t instanceof HTMLVideoElement&&t.poster?[2,P(t,r)]:[2,Promise.resolve(t.cloneNode(!1))]}))}))}(t,r)})).then((function(o){return function(t,r,o){var i;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){var u;return 0===(n=null!=(u=t).tagName&&"SLOT"===u.tagName.toUpperCase()&&t.assignedNodes?l(t.assignedNodes()):l((null!==(i=t.shadowRoot)&&void 0!==i?i:t).childNodes)).length||t instanceof HTMLVideoElement?[2,Promise.resolve(r)]:[2,n.reduce((function(t,n){return t.then((function(){return x(n,o)})).then((function(t){t&&r.appendChild(t)}))}),Promise.resolve()).then((function(){return r}))]}))}))}(t,o,r)})).then((function(n){return S(t,n)}))]:[2,Promise.resolve(null)]}))}))}var E=/url\((['"]?)([^'"]+?)\1\)/g,T=/url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g,C=/src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;function R(t){var n=[];return t.replace(E,(function(t,e,r){return n.push(r),t})),n.filter((function(t){return!c(t)}))}function L(t,n,e,r,o){var i=e?function(t,n){if(t.match(/^[a-z]+:\/\//i))return t;if(t.match(/^\/\//))return window.location.protocol+t;if(t.match(/^[a-z]+:/i))return t;var e=document.implementation.createHTMLDocument(),r=e.createElement("base"),o=e.createElement("a");return e.head.appendChild(r),e.body.appendChild(o),n&&(r.href=n),o.href=t,o.href}(n,e):n;return Promise.resolve(i).then((function(t){return o?o(t):m(t,r)})).then((function(t){return"string"==typeof t?f(t,u(n)):f(t.blob,u(n)||t.contentType)})).then((function(e){return t.replace((r=n.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1"),new RegExp("(url\\(['\"]?)("+r+")(['\"]?\\))","g")),"$1"+e+"$3");var r})).then((function(t){return t}),(function(){return i}))}function N(t){return-1!==t.search(E)}function k(t,r,o){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return N(t)?(n=function(t,n){var e=n.preferredFontFormat;return e?t.replace(C,(function(t){for(;;){var n=T.exec(t)||[],r=n[0],o=n[2];if(!o)return"";if(o===e)return"src: "+r+";"}})):t}(t,o),[2,Promise.resolve(n).then(R).then((function(t){return t.reduce((function(t,n){return t.then((function(t){return L(t,n,r,o)}))}),Promise.resolve(n))}))]):[2,Promise.resolve(t)]}))}))}function A(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(o){return t instanceof Element?[2,Promise.resolve(t).then((function(t){return function(t,r){var o;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return(n=null===(o=t.style)||void 0===o?void 0:o.getPropertyValue("background"))?[2,Promise.resolve(n).then((function(t){return k(t,null,r)})).then((function(n){return t.style.setProperty("background",n,t.style.getPropertyPriority("background")),t}))]:[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return t instanceof HTMLImageElement&&!c(t.src)||t instanceof SVGImageElement&&!c(t.href.baseVal)?(n=t instanceof HTMLImageElement?t.src:t.href.baseVal,[2,Promise.resolve(n).then((function(t){return m(t,r)})).then((function(t){return f(t.blob,u(n)||t.contentType)})).then((function(n){return new Promise((function(e,r){t.onload=e,t.onerror=r,t instanceof HTMLImageElement?(t.srcset="",t.src=n):t.href.baseVal=n}))})).then((function(){return t}),(function(){return t}))]):[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n,o;return e(this,(function(e){return n=l(t.childNodes),o=n.map((function(t){return A(t,r)})),[2,Promise.all(o).then((function(){return t}))]}))}))}(t,r)}))]:[2,Promise.resolve(t)]}))}))}var I={};function M(t){var n=I[t];if(null!=n)return n;var e=window.fetch(t).then((function(n){return{url:t,cssText:n.text()}}));return I[t]=e,e}function D(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,t.cssText.then((function(n){var e=n,r=/url\(["']?([^"')]+)["']?\)/g,o=(e.match(/url\([^)]+\)/g)||[]).map((function(n){var o=n.replace(r,"$1");return o.startsWith("https://")||(o=new URL(o,t.url).href),window.fetch(o).then((function(t){return t.blob()})).then((function(t){return new Promise((function(r,o){var i=new FileReader;i.onloadend=function(){e=e.replace(n,"url("+i.result+")"),r([n,i.result])},i.onerror=o,i.readAsDataURL(t)}))}))}));return Promise.all(o).then((function(){return e}))}))]}))}))}function V(t){if(null==t)return[];for(var n=[],e=t.replace(/(\/\*[\s\S]*?\*\/)/gi,""),r=new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})","gi");;){if(null===(u=r.exec(e)))break;n.push(u[0])}e=e.replace(r,"");for(var o=/@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,i=new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})","gi");;){var u;if(null===(u=o.exec(e))){if(null===(u=i.exec(e)))break;o.lastIndex=i.lastIndex}else i.lastIndex=o.lastIndex;n.push(u[0])}return n}function H(t){return t.filter((function(t){return t.type===CSSRule.FONT_FACE_RULE})).filter((function(t){return N(t.style.getPropertyValue("src"))}))}function U(t){return n(this,void 0,void 0,(function(){return e(this,(function(r){return[2,new Promise((function(n,e){null==t.ownerDocument&&e(new Error("Provided element is not within a Document")),n(l(t.ownerDocument.styleSheets))})).then((function(t){return function(t){return n(this,void 0,void 0,(function(){var n,r;return e(this,(function(e){return n=[],r=[],t.forEach((function(n){if("cssRules"in n)try{l(n.cssRules).forEach((function(t,e){if(t.type===CSSRule.IMPORT_RULE){var o=e+1,i=M(t.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){try{n.insertRule(t,t.startsWith("@import")?o+=1:n.cssRules.length)}catch(n){console.error("Error inserting rule from remote css",{rule:t,error:n})}}))})).catch((function(t){console.error("Error loading remote css",t.toString())}));r.push(i)}}))}catch(o){var e=t.find((function(t){return null==t.href}))||document.styleSheets[0];null!=n.href&&r.push(M(n.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){e.insertRule(t,n.cssRules.length)}))})).catch((function(t){console.error("Error loading remote stylesheet",t.toString())}))),console.error("Error inlining remote css file",o.toString())}})),[2,Promise.all(r).then((function(){return t.forEach((function(t){if("cssRules"in t)try{l(t.cssRules).forEach((function(t){n.push(t)}))}catch(n){console.error("Error while reading CSS rules from "+t.href,n.toString())}})),n}))]}))}))}(t)})).then(H)]}))}))}function j(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,U(t).then((function(t){return Promise.all(t.map((function(t){var n=t.parentStyleSheet?t.parentStyleSheet.href:null;return k(t.cssText,n,r)})))})).then((function(t){return t.join("\n")}))]}))}))}function F(t,n){void 0===n&&(n={});var e=n.width||function(t){var n=h(t,"border-left-width"),e=h(t,"border-right-width");return t.clientWidth+n+e}(t),r=n.height||function(t){var n=h(t,"border-top-width"),e=h(t,"border-bottom-width");return t.clientHeight+n+e}(t);return{width:e,height:r}}function B(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var o,i,u;return e(this,(function(c){return o=F(t,r),i=o.width,u=o.height,[2,Promise.resolve(t).then((function(t){return x(t,r,!0)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,(null!=r.fontEmbedCSS?Promise.resolve(r.fontEmbedCSS):j(t,r)).then((function(n){var e=document.createElement("style"),r=document.createTextNode(n);return e.appendChild(r),t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e),t}))]}))}))}(t,r)})).then((function(t){return A(t,r)})).then((function(t){return function(t,n){var e=t.style;n.backgroundColor&&(e.backgroundColor=n.backgroundColor),n.width&&(e.width=n.width+"px"),n.height&&(e.height=n.height+"px");var r=n.style;return null!=r&&Object.keys(r).forEach((function(t){e[t]=r[t]})),t}(t,r)})).then((function(t){return function(t,r,o){return n(this,void 0,void 0,(function(){var n,i,u;return e(this,(function(e){return n="http://www.w3.org/2000/svg",i=document.createElementNS(n,"svg"),u=document.createElementNS(n,"foreignObject"),i.setAttribute("width",""+r),i.setAttribute("height",""+o),i.setAttribute("viewBox","0 0 "+r+" "+o),u.setAttribute("width","100%"),u.setAttribute("height","100%"),u.setAttribute("x","0"),u.setAttribute("y","0"),u.setAttribute("externalResourcesRequired","true"),i.appendChild(u),u.appendChild(t),[2,p(i)]}))}))}(t,i,u)}))]}))}))}var O=16384;function $(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,B(t,r).then(v).then((function(n){var e=document.createElement("canvas"),o=e.getContext("2d"),i=r.pixelRatio||function(){var t,n;try{n=process}catch(t){}var e=n&&n.env?n.env.devicePixelRatio:null;return e&&(t=parseInt(e,10),Number.isNaN(t)&&(t=1)),t||window.devicePixelRatio||1}(),u=F(t,r),c=u.width,f=u.height,a=r.canvasWidth||c,s=r.canvasHeight||f;return e.width=a*i,e.height=s*i,r.skipAutoScale||function(t){(t.width>O||t.height>O)&&(t.width>O&&t.height>O?t.width>t.height?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O):t.width>O?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O))}(e),e.style.width=""+a,e.style.height=""+s,r.backgroundColor&&(o.fillStyle=r.backgroundColor,o.fillRect(0,0,e.width,e.height)),o.drawImage(n,0,0,e.width,e.height),e}))]}))}))}t.getFontEmbedCSS=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,j(t,r)]}))}))},t.toBlob=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then(d)]}))}))},t.toCanvas=$,t.toJpeg=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL("image/jpeg",r.quality||1)}))]}))}))},t.toPixelData=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var n,o,i;return e(this,(function(e){return n=F(t,r),o=n.width,i=n.height,[2,$(t,r).then((function(t){return t.getContext("2d").getImageData(0,0,o,i).data}))]}))}))},t.toPng=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL()}))]}))}))},t.toSvg=B,Object.defineProperty(t,"__esModule",{value:!0})}));

const saveModalBtn = document.getElementById('saveModal')
saveModalBtn.addEventListener('click' , (e) => {
    htmlToImage.toJpeg(document.getElementById('reportModal'), { quality: 0.95 })
  .then(function (dataUrl) {
    var link = document.createElement('a');
    var rptFileName = identifier.patient
    link.download = `${rptFileName}.jpeg`;
    link.href = dataUrl;
    link.click();
  });
    console.log(e);
});

const newWorkBtn = document.querySelector("#worksheets-btn");
newWorkBtn.addEventListener("click", (e) => {
  populate();
  console.log(e);
});
function showPatID() {
  document.getElementById("patientId").style.display = "block";
}
function hideRequired() {
    let required = document.querySelectorAll('.required')
    required.forEach( function (element) {
      element.style.display = 'none';
  })
  };

const togMenuBtn = document.querySelector("#togMenu");

togMenuBtn.addEventListener("click", (e) => {
  myFunction();
  console.log(e);
});
function myFunction() {
  var x = document.getElementById("navDemo");
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else {
    x.className = x.className.replace(" w3-show", "");
  }
}
function printReport() {
  document.getElementById("nonPrintable").className += "noPrint";
  window.print();
}
const printReportBtn = document.querySelector("#printReport");
printReportBtn.addEventListener("click", (e) => {
  printReport();
  console.log(e);
});

function showReportModal() {
  document.getElementById("reportModal").style.display = "block";

}
function closeReportModal() {
  document.getElementById("reportModal").style.display = "none";
  
}
function hideDiv(id) {
    document.getElementById(id).style.display = 'none';
    }

function showImpModal() {
  if (history.confirmed === false) {
    document.getElementById('impression').style.display = 'block';
  }
}


window.onclick = function (event) {
  if (
    event.target.id == "id01" ||
    event.target.id == "id02" ||
    event.target.id == "id03" ||
    event.target.id == "id04" ||
    event.target.id == "id05" ||
    event.target.id == "reportModal" ||
    event.target.id == "patientId" 
  ) {
    document.getElementById(event.target.id).style.display = "none";
  } if (event.target.id == 'impression') {
    document.getElementById(event.target.id).style.display = "none";
    history.confirmed = true
  }
};
function showDiv(id) {
    var x = document.getElementById(id);
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
  }

const history = {
  patID : "",
  side : "",
  
  
  onset : "",
  symptoms : "",
  rom : "",
  trauma : "",
  roi : "",
  impression : '',
  confirmed : false,
  reportLine : function () {
    history.reportLine = clinReport();
  },
}
const identifier =  {
  patient: "",
  sono : "",
  reported : false
}

function getPatID() {
  document.querySelector("#patIdLine").innerHTML = boldString("Patient Identifier  -  ",'Patient Identifier') + identifier.patient
  document.querySelector("#sonoIdLine").innerHTML = boldString('Sonographer  -  ','Sonographer') + identifier.sono;
  
}

const pDSubBtn = document.querySelector("#patDetSub");
pDSubBtn.addEventListener("click", (e) => {
  
  identifier.patient = document.getElementById('patDet').value;
  identifier.sono = document.getElementById('sono').value;
  getPatID();
  hideDiv('patientId')
  populate();
  console.log(e);
});
const accImpBtn = document.querySelector("#accImp");
accImpBtn.addEventListener("click", (e) => {
    document.getElementById("impression").style.display = "none";
    history.confirmed = true
   updateClin();
  console.log(e);
});
const req = document.querySelector('#req');
const sideBtn = document.querySelectorAll(".hisSide");
sideBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    history.side = e.target.textContent;
    req.style.display = 'none'
    if (identifier.reported === true) {
        populate();
    }
    console.log(e);
  });
});

const hisOnsBtn = document.querySelectorAll(".hisOns");
hisOnsBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    history.onset = e.target.id;
    history.confirmed = false
    console.log(e);
  });
});
const hisSymBtn = document.querySelectorAll(".hisSym");
hisSymBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    history.symptoms = e.target.textContent;
    history.confirmed = false
    console.log(e);
  });
});

const hisRomBtn = document.querySelectorAll(".hisRom");
hisRomBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    history.rom = e.target.textContent;
    history.confirmed = false
    console.log(e);
  });
});

const hisTraBtn = document.querySelectorAll(".hisTra");
hisTraBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    history.trauma = e.target.id;
    history.confirmed = false
    console.log(e);
  });
});

const hisRoiBtn = document.querySelectorAll(".hisRoi");
hisRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    history.roi = e.target.textContent;
    history.confirmed = false
    console.log(e);
  });
});
const hisImpBtn = document.querySelectorAll(".hisImp");
hisImpBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    history.impression = e.target.id;
    history.confirmed = true;
   document.getElementById("impression").style.display = "none";
   document.getElementById('reportModal').style.display = 'none';
   updateClin();
    console.log(e);
  });
});


function clinImpression() {
  
  
  if (history.roi === "AC joint" && history.trauma === "Recent sporting injury. ") {
    history.impression = "AC joint injury";
  } else if (history.roi === "AC joint") {
    history.impression = "AC joint arthrosis";
  } else if (
    history.rom === "Global limited ROM. " 
     &&
    history.trauma === "No recent trauma. "
  ) {
    history.impression = "rotator cuff syndrome or GHJ abnormality. ";
  
  } else if (
    history.rom === "Normal ROM. " ||
    history.rom === "Limited abduction and IR. " ||
    history.rom === "Limited abduction. "
  ) {
    history.impression = "subacromial impingement";
  } else if (
    history.symptoms === "severe pain. " &&
    history.rom === "Global limited ROM. " &&
    history.onset === "Acute onset " 
  ) {
    history.impression = "acute calcific tendinitis";
  } else if (
    history.symptoms === "severe pain. " &&
    history.rom === "Global limited ROM. "
  ) {
    history.impression = "rotator cuff syndrome or GHJ abnormality";
  }  else if (
    (history.rom === "Limited abduction and ER. " ||
      history.rom === "Global limited ROM. ") &&
    history.trauma !== "No recent trauma. " && history.trauma !== ''
  ) {
    history.impression = "possible GHJ injury";
  } else if (
    history.rom === "Limited abduction and ER. " ||
    (history.rom === "Global limited ROM. "  &&
      history.onset === "Persistent symptoms")
  ) {
    history.impression = "GHJ abnormality";
  } else {
    history.impression = '';
  }
}

function clinReport() {
  
    history.reportLine =
      history.onset +
      history.symptoms  + history.rom + history.trauma
      
      if (history.roi !== '') {
        history.reportLine += 'Localised tenderness at the ' + history.roi + '. '
      } if (history.impression !== '') {
        history.reportLine += ' Presentation suggestive of ' + history.impression + '.'
      }
  } 
function updateClin() {
  clinReport();
  document.getElementById("hisRpt").innerHTML = boldString("Clinical  -  ","Clinical ") + history.reportLine; 
  showReportModal();
}

function addClin() {
  if (history.confirmed === false) {
    clinImpression();
   
  }
  clinReport();
  if (history.reportLine === '') {
    history.reportLine = "No details provided. "
  }
  document.getElementById("hisRpt").innerHTML = boldString("Clinical  -  ","Clinical ") + history.reportLine; 
  addTitle();
}



function boldString(str, substr) {
  var strRegExp = new RegExp(substr, 'g');
  return str.replace(strRegExp, '<b><i>'+substr+'</i></b>');
}




const biceps = {
  finding: "normBic",
  location: "Enlocated. ",
  effusion: "",
  sheathVasc: "",
  thickness: "",
  texture: "",
  tear: "",
  atrophy: "",
  diagnosis: "",
  other : '',
  reportLine: function getRptLine() {
    reportLine = bicepsReport();
  },
};
const bicOtherText = document.querySelector('#bicOth')
  bicOtherText.addEventListener("focusout", (e) => {
      biceps.other = e.target.value
  });

const rotInt = {
  finding: "",
  abnQual: "",
  involve: "",
  repLine: function() {
    rotInt.repLine = RIRep();
  },
};
function RIRep() {
  if (biceps.location !== "Enlocated. ") {
    rotInt.finding === "abnormal appearance";
    rotInt.repLine = "";
  } else if (
    rotInt.finding === "" &&
    biceps.location === "Enlocated. "
  ) {
    rotInt.repLine = "";
  } else if (
    biceps.location !== "Enlocated. " ||
    rotInt.finding !== "" ||
    rotInt.abnQual !== ""
  ) {
    rotInt.repLine =
      "Rotator interval " +
      rotInt.abnQual +
      " involving the " +
      rotInt.involve +
      ".";
  } else if (biceps.finding === "normBic") {
    rotInt.repLine = "";
  } else {
    rotInt.repLine = "";
  }
}

const RIAbnDiv = document.querySelector(".RIAbnDiv");
const rotIntNormBtn = document.querySelector(".rotIntNorm");
rotIntNormBtn.addEventListener("click", (e) => {
  RIAbnDiv.style.display = "none";
  rotInt.finding = e.target.id;
  rotInt.repLine = "normal";
  console.log(e);
});

const rotIntAbnBtn = document.querySelector(".rotIntAbn");
rotIntAbnBtn.addEventListener("click", (e) => {
  RIAbnDiv.style.display = "block";
  rotInt.finding = e.target.id;
  biceps.finding = ''
  console.log(e);
});

const rotIntAQBtn = document.querySelectorAll(".rotIntAQ");
rotIntAQBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    rotInt.abnQual = e.target.id;
    rotIntRequired.style.display = 'none';
    rotInt.finding = "abnormal appearance";
    console.log(e);
  });
});
const rotIntRequired = document.querySelector('#reqRot')
const rotIntInvBtn = document.querySelectorAll(".rotIntInv");
rotIntInvBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    rotInt.involve = e.target.id;
    rotIntRequired.style.display = 'inline'; 
    rotInt.finding = "abnormal appearance";
    console.log(e);
  });
});

const bicAtrBtn = document.querySelectorAll(".bicAtrophy");
bicAtrBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    biceps.atrophy = e.target.id;
    biceps.finding = '';
    console.log(e);
  });
});

const bicTearBtn = document.querySelectorAll(".bicTear");
bicTearBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    biceps.tear = e.target.id;
    biceps.finding = '';
    console.log(e);
  });
});
const rotNorDiv = document.querySelector("#rotNor");
const bicLocatBtn = document.querySelectorAll(".bicLocat");
bicLocatBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    biceps.location = e.target.id;
    if (biceps.location !== 'Enlocated. ') {
      biceps.finding = '';
    }
    console.log(e);

    if (biceps.location !== "Enlocated. ") {
      rotNorDiv.style.display = "none";
    }
    if (biceps.location === "Enlocated. ") {
      rotNorDiv.style.display = "inline";
    }
  });
});

const buttons = document.querySelectorAll(".effusion");
buttons.forEach((button) => {
  button.addEventListener("click", (e) => {
    biceps.effusion = e.target.id;
    biceps.finding = '';
    console.log(e);
  });
});






const bicepThBtn = document.querySelectorAll(".bicepsTh");
bicepThBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    biceps.thickness = e.target.id;
    biceps.finding = '';
    console.log(e);
  });
});
const bicepVascBtn = document.querySelectorAll(".sheathVasc");
bicepVascBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    biceps.sheathVasc = e.target.id;
    biceps.finding = '';
    console.log(e);
  });
});
const bicTextureBtn = document.querySelectorAll(".bicTexture");
bicTextureBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    biceps.texture = e.target.id;
    biceps.finding = '';
    console.log(e);
  });
});



function bicepsReport() {
  bicepsDiagnosis();
  if (biceps.finding === "normBic") {
    biceps.reportLine =
      "Normal appearance at biceps and rotator interval. ";
  } else if (
    biceps.tear !== "" &&
    biceps.tear !== "Intrasubstance tear. "
  ) {
    biceps.reportLine =
      biceps.tear  + biceps.atrophy  + biceps.other + rotInt.repLine ;
  } else {
    biceps.reportLine =
      
      biceps.location + biceps.effusion + biceps.sheathVasc + biceps.thickness + biceps.texture + biceps.tear  + biceps.atrophy + biceps.other
  } if (biceps.diagnosis !== '' ) {
    biceps.reportLine += " Appearances consistent with " +biceps.diagnosis + '. '
  } if (rotInt.repLine !== '') {
    biceps.reportLine += rotInt.repLine
  }
}
function addBic() {
  RIRep();
  bicepsReport();
  
    document.getElementById("bicRpt").innerHTML = boldString("Biceps Tendon  -  ","Biceps Tendon ") + biceps.reportLine;
    
  }



function bicepsDiagnosis() {
  if (
    biceps.diagnosis === "biceps tenosynovitis" &&
    biceps.sheathVasc === "Normal sheath vascularity. "
  ) {
    biceps.diagnosis = "normal biceps tendon";
    bicepsDiagnosis();
  } else if (
    biceps.diagnosis === "biceps tendinosis" &&
    biceps.thickness === "Normal thickness, " &&
    biceps.texture === "homogeneous. " &&
    biceps.tear === ""
  ) {
    biceps.diagnosis = "normal biceps tendon";
    bicepsDiagnosis();
  } else if (
    biceps.thickness === "Thickened, " ||
    biceps.thickness === "Atrophic, " ||
    biceps.texture === "heterogeneous. " ||
    biceps.tear === "Intrasubstance tear. "
  ) {
    biceps.diagnosis = "biceps tendinosis";
  } else if (
    (biceps.effusion !== "" && biceps.effusion !== 'No sheath effusion. ') && (biceps.sheathVasc !== "Normal sheath vascularity. " && biceps.sheathVasc !== "")
    
  ) {
    biceps.diagnosis = "biceps tenosynovitis";
  } else {
    return;
  }
}
/*
function RIRepDisp() {
  if (rotInt.repLine !== "normal") {
    biceps.reportLine = biceps.reportLine + rotInt.repLine;
  } else if (rotInt.repLine === "normal") {
    biceps.reportLine = `${biceps.reportLine}`;
  }
}
*/

const supra = {
    id : 'supra',
    name : 'Supraspinatus',
    finding : ' Normal. ',
    primary : '',
    primDim : '',
    primLoc : '',
    diagnosis : '',
    tear : "",
    tearDim : '',
    tearLoc : '',
    secondary : '', 
    secDim : '',
    secLoc : '',
    other : '',
} 
const supraText = document.querySelectorAll('.supraText')       
   supraText.forEach((element) => {
      element.addEventListener('focusout', function (e) {
      let property = this.dataset.prop;
      supra[property] = e.target.value;
      console.log(e);
      });
   });  
  
   const supraBtn = document.querySelectorAll(".supraBtn")
   supraBtn.forEach((button) => {
    button.addEventListener("click", function  (e)  {
    property = this.dataset.prop;
      supra[property] = e.target.id;
      console.log(e);
    });
   });
   const infra = {
    id : 'infra',
    name : 'Infraspinatus',
    finding : ' Normal. ',
    primary : '',
    primDim : '',
    primLoc : '',
    diagnosis : '',
    tear : "",
    tearDim : '',
    tearLoc : '',
    secondary : '', 
    secDim : '',
    secLoc : '',
    other : '',
  } 
  const infraText = document.querySelectorAll('.infraText')       
   infraText.forEach((element) => {
      element.addEventListener('focusout', function (e) {
      let property = this.dataset.prop;
      infra[property] = e.target.value;
      console.log(e);
      });
   });  
  
   const infraBtn = document.querySelectorAll(".infraBtn")
   infraBtn.forEach((button) => {
    button.addEventListener("click", function  (e)  {
    property = this.dataset.prop;
      infra[property] = e.target.id;
      console.log(e);
    });
   });
   const subscap = {
    id : 'subscap',
    name : 'Subscapularis',
    finding : ' Normal. ',
    primary : '',
    primDim : '',
    primLoc : '',
    diagnosis : '',
    tear : "",
    tearDim : '',
    tearLoc : '',
    secondary : '', 
    secDim : '',
    secLoc : '',
    other : '',
  } 
  const subscapText = document.querySelectorAll('.subscapText')       
   subscapText.forEach((element) => {
      element.addEventListener('focusout', function (e) {
      let property = this.dataset.prop;
      subscap[property] = e.target.value;
      console.log(e);
      });
   });  
  
   const subscapBtn = document.querySelectorAll(".subscapBtn")
   subscapBtn.forEach((button) => {
    button.addEventListener("click", function  (e)  {
    property = this.dataset.prop;
      subscap[property] = e.target.id;
      console.log(e);
    });
   });



function updateFinding(obj) {
  if (obj.tear !== "" || obj.primary !== '' || obj.secondary !== "" || obj.other !== '') {
        obj.finding = '';
  } if (supra.tear === ' complete full thickness tear, with extension into infraspinatus. ') {
    infra.finding = 'Tear extending from supraspinatus. ';
  }
};
   


   function addCuffTendon(obj) {
       updateFinding(obj)
    document.getElementById(`${obj.id}Rpt`).innerHTML = `${boldString(obj.name +'  -  ', obj.name)} ${obj.finding}
    ${obj.tearDim + obj.tear +  obj.tearLoc}  ${obj.primDim} ${obj.primary + obj.primLoc + obj.diagnosis} ${obj.secDim + obj.secondary + obj.secLoc + obj.other}`;
    if (obj.diagnosis === '') {
      document.getElementById(`${obj.id}Rpt`).innerHTML = `${boldString(obj.name +'  -  ', obj.name)} ${obj.finding}
    ${obj.tearDim + obj.tear +  obj.tearLoc}  ${obj.primDim} ${obj.primary + obj.primLoc + '. '} ${obj.secDim + obj.secondary + obj.secLoc + obj.other}`;
    }
    } 


const bursa = {
  finding : "normal",
  dimension : '',
  thickness : "Normal thickness. ",
  effusion : "",
  fibrosis : "",
  impingement : "No impingement demonstrated. ",
  other : '',

  diagnosis : "",
  reportLine : function () {
    reportLine = bursaReport();
  },
}



const bursaNormalBtn = document.querySelector(".normBursa");
bursaNormalBtn.addEventListener("click", (e) => {

  bursa.finding = e.target.id;
  console.log(e);
});


const burThkBtn = document.querySelectorAll(".bursThk");
burThkBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.thickness = e.target.id;
    console.log(e);
  });
});
const burEffBtn = document.querySelectorAll(".bursEff");
burEffBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.effusion = e.target.id;
    console.log(e);
  });
});
const burFibBtn = document.querySelectorAll(".bursFib");
burFibBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.fibrosis = e.target.id;
    console.log(e);
  });
});
const burImpBtn = document.querySelectorAll(".bursImp");
burImpBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.impingement = e.target.id;
    console.log(e);
  });
});
const burOthText = document.querySelector('#burOthText')
  burOthText.addEventListener("focusout", (e) => {
      bursa.other = e.target.value
  });
  const burDimText = document.querySelector('#burDimText')
  burDimText.addEventListener("focusout", (e) => {
      bursa.dimension = e.target.value
  });
function addBursa() {
  
  bursaReport();
  document.getElementById("bursaRpt").innerHTML = boldString('Subacromial Bursa  -  ','Subacromial Bursa') + bursa.reportLine;
  addAcj();
}



function bursaReport() {
    bursa.reportLine = `${bursa.dimension}. ${bursa.thickness} ${bursa.effusion} ${bursa.fibrosis} ${bursa.impingement} ${bursa.other}`
}

const acj = {
  finding : "Normal. ",
  capsule : "",
  vasc : "",
  ganglion : "",
  bone : "",
  injury : "",
  tender : "",
  dimension : '',
  diagnosis : '',
  other : '',
  reportLine : function () {
    acj.reportLine = acjReport();
  },
}

const acjOthText = document.querySelector('#acjOthText')
  acjOthText.addEventListener("focusout", (e) => {
      acj.finding = '';
      acj.other = e.target.value
  });
  const acjDimText = document.querySelector('#acjDimText')
  acjDimText.addEventListener("focusout", (e) => {
    acj.finding = '';
      acj.dimension = e.target.value
  });
const acjNormalBtn = document.querySelector(".normAcj");
acjNormalBtn.addEventListener("click", (e) => {
  
  acj.finding = "Normal. ";
  
  console.log(e);
});


const acjCapBtn = document.querySelectorAll(".acjCap");
acjCapBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    acj.finding = '';
    acj.capsule = e.target.id;
    console.log(e);
  });
});
const acjVasBtn = document.querySelectorAll(".acjVas");
acjVasBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    acj.finding = '';
    acj.vasc = e.target.id;
    console.log(e);
  });
});
const acjGangBtn = document.querySelector(".acjGan");
acjGangBtn.addEventListener("click", (e) => {
  acj.ganglion = e.target.id;
  acj.finding = '';
  console.log(e);
});

const acjBonBtn = document.querySelectorAll(".acjBon");
acjBonBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    acj.bone = e.target.id;
    acj.finding = '';
    console.log(e);
  });
});
const acjInjBtn = document.querySelectorAll(".acjInj");
acjInjBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    acj.injury = e.target.id;
    acj.finding = '';
    console.log(e);
  });
});
const acjTenBtn = document.querySelectorAll(".acjTen");
acjTenBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    acj.tender = e.target.id;
    acj.finding = '';
    console.log(e);
  });
});



function addAcj() {
  
  acjReport();
  document.getElementById("acjRpt").innerHTML = boldString('AC Joint  -  ','AC Joint') + acj.reportLine;
  showReportModal();
}

function acjDiagnosis() {
  if (history.trauma === "No recent trauma. " || history.trauma === ''|| acj.bone === 'Mild osteolysis. ' || acj.bone === 'Significant osteolysis. ') {
    return;
  } else if (acj.bone === 'Mild degenerative change. ' || acj.bone === 'Significant degenerative change. ' && acj.tender === 'Tender to palpation. ' ) {
    acj.diagnosis = "Suggestive of ACJ arthrosis with possible ACJ injury. ";
  } else if (
    acj.injury === "Mild elevation of the clavicle. " &&
    acj.vasc !== "Hyperaemia. "
  ) {
    acj.diagnosis = "Suggestive of at least low grade ACJ injury. ";
  } else if (
    acj.injury !== "" &&
    (acj.capsule === "Thickening and periarticular oedema. " ||
      acj.vasc === "Hyperaemia. ")
  ) {
    acj.diagnosis = "Suggestive of at least moderate grade ACJ injury. ";
  } else if (
    
    acj.capsule === "Capsular thickening and periarticular oedema. " ||
      acj.vasc === "Hyperaemia. "
  ) {
    acj.diagnosis = "Suggestive of at least low grade ACJ injury. ";
  } else if (
    history.trauma !== "No recent trauma. " && 
    acj.tender === "Tender to palpation. " &&
    acj.capsule !== ""
  ) {
    acj.diagnosis = "Suggestive of low grade ACJ injury. ";
  }
}

function acjReport() {
  acjDiagnosis();
  if (acj.finding === "Normal. ") {
    acj.reportLine = acj.finding;
  } else {
    acj.reportLine =
      
      acj.tender +
    
      acj.injury +
      
      acj.capsule +
      
      acj.vasc +
      
      acj.diagnosis + acj.dimension + acj.ganglion + acj.bone + acj.other;
}
}

const ghj = {
  finding : "Normal. ",
  capsule : "",
  ighl : "",
  effusion : "",
  paralab : "",
  osteo : "",
  dimension : "",
  other : '',
  diagnosis : "",
  trauma : "",
  reportLine : function () {
    ghj.reportLine = ghjReport();
  },
}

const ghjOthText = document.querySelector('#ghjOthText')
  ghjOthText.addEventListener("focusout", (e) => {
      ghj.finding = '';
      ghj.other = e.target.value;
  });
  const ghjParText = document.querySelector('#ghjParDim')
  ghjParText.addEventListener("focusout", (e) => {
      ghj.finding = '';
      ghj.dimension = e.target.value;
  });
const ghjNormalBtn = document.querySelector(".normGhj");
ghjNormalBtn.addEventListener("click", (e) => {
 ghj.finding = "Normal. ";
  console.log(e);
});



const ghjCapBtn = document.querySelectorAll(".ghjCap");
ghjCapBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    ghj.capsule = e.target.id;
    ghj.finding = "";
    console.log(e);
  });
});
const ghjIglBtn = document.querySelectorAll(".ghjIgl");
ghjIglBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    ghj.ighl = e.target.id;
    ghj.finding = "";
    console.log(e);
  });
});
const ghjEffBtn = document.querySelectorAll(".ghjEff");
ghjEffBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    ghj.effusion = e.target.id;
    ghj.finding = "";
    console.log(e);
  });
});

const ghjParBtn = document.querySelectorAll(".ghjPar");
ghjParBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    ghj.paralab = e.target.id;
    ghj.finding = "";
    console.log(e);
  });
});
const ghjOstBtn = document.querySelectorAll(".ghjOst");
ghjOstBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    ghj.osteo = e.target.id;
    ghj.finding = "";
    console.log(e);
  });
});
function addGhj() {
  
  ghjReport();
  document.getElementById("ghjRpt").innerHTML = boldString("Glenohumeral Joint  -  ","Glenohumeral Joint") + ghj.reportLine;
}



function ghjDiagnosis() {
  
  if (ghj.paralab === "paralabral cyst. " && ghj.osteo !== "") {
    ghj.diagnosis = "probable labral tear with associated degenerative change";
  } else if (ghj.paralab === "paralabral cyst. ") {
    ghj.diagnosis = "probable labral tear";
  } else if (
    ghj.osteo === "Prominent inferior humeral osteophyte. " ||
    ghj.paralab === "Bony remodelling at the posterior aspect. "
  ) {
    ghj.diagnosis = "advanced degenerative change";
  } else if (
    ghj.osteo === "Small inferior humeral osteophyte. " ||
    ghj.osteo === "Mild bony remodelling of inferior margin of joint. "
  ) {
    ghj.diagnosis = "mild degenerative change";
  } else if (
    history.onset === 'Acute onset ' && history.trauma !== 'No recent trauma. ' &&
  
    (ghj.effusion !== "" || ghj.ighl !== '' ||
      biceps.effusion === " Significant sheath effusion. ")
  ) {
    ghj.diagnosis =
      "possible GHJ injury. Internal derangement cannot be excluded";
  } else if (
    history.onset === 'Subacute onset ' && history.trauma !== 'No recent trauma. ' &&
  
    (ghj.effusion !== "" || ghj.ighl !== '' ||
      biceps.effusion === " Significant sheath effusion. ")
  ) {
    ghj.diagnosis =
      "possible GHJ injury. Internal derangement or evolving adhesive capsulitis cannot be excluded";
  } else if  (ghj.ighl !== '' &&  (supra.tear === ' articular surface tear ' || supra.tear === ' full thickness partial width tear '
   || supra.tear === " complete full thickness tear. " || supra.tear === ' complete full thickness tear, retracted under acromion. '
   || supra.tear === ' complete full thickness tear, with extension into infraspinatus. ')) {
    ghj.diagnosis = "synovitis, possibly secondary to rotator cuff tear";
  }
  else if (
    ghj.ighl !== "" &&
    rotInt.finding === "abnormal appearance" &&
    ghj.capsule !== "" &&
    history.impression === "adhesive capsulitis"
  ) {
    ghj.diagnosis = "adhesive capsulitis";
  } else if (ghj.ighl === "Significantly thickened IGHL. ") {
    ghj.diagnosis = "probable adhesive capsulitis";
  } else if (
    ghj.capsule !== ""  && history.impression === "adhesive capsulitis")
     {
    ghj.diagnosis = "probable adhesive capsulitis";
  } else if (ghj.ighl === "Mildly thickened IGHL. ") {
    ghj.diagnosis = "probable evolving adhesive capsulitis";
  } else {
      ghj.diagnosis = '';
  }
}

function ghjReport() {
  ghjDiagnosis();
  if (ghj.finding === "Normal. ") {
    ghj.reportLine = ghj.finding;
  } else {
      ghj.reportLine = ghj.effusion + ghj.capsule + ghj.ighl + ghj.osteo + ghj.other + '. '
  
  } if (ghj.paralab === "paralabral cyst. ") {
    ghj.reportLine +=
      ghj.dimension + ' ' +
      
      ghj.paralab;
  } if (ghj.diagnosis !== '') {
      ghj.reportLine += " Appearances consistent with " + ghj.diagnosis;
  } 
}



const add = {
  other : '',
}
const addOthText = document.querySelector('#addOthText')
  addOthText.addEventListener("focusout", (e) => {
      add.other = e.target.value
  });

 function addOther() {
   if (add.other !== '') {
    document.getElementById('addRpt').innerHTML = boldString('Additional Findings  -  ','Additional Findings') + add.other;
   }
 } 

function checkID() {
 if (identifier.patient === '' || identifier.sono === '') {
  showPatID();
 }
}
function checkSide() {
    document.getElementById('clinSection').click();
   };

   function addTitle() {
    if (history.side !== "" )  {
         document.getElementById('hisTitleRpt').innerHTML = `${history.side}`;
      } else  {
         checkSide();
      }
    }

function populate() {
  checkID();
  if (identifier.patient === '' || identifier.sono === '' ) {
    return
   }
  addClin();
  if (history.side === "" ) {
     return
  }
  addBic();
  
  addBursa();
  addAcj();
  addGhj();
  addOther();
  addCuffTendon(subscap);
  addCuffTendon(supra);
  addCuffTendon(infra);
  showReportModal();
  }
  
  

  
  
  
  

    
    
const openWSBtn = document.querySelector("#panRep");
openWSBtn.addEventListener("click", () => {
  identifier.reported = true;
  populate();
});

const reOpenWSBtn = document.querySelector("#savRep");
reOpenWSBtn.addEventListener("click", () => {
  showReportModal();
});




  /*
  const buttonScroller = Array.from(document.getElementsByTagName('button'));
  buttonScroller.forEach((element) =>  {
    element.addEventListener('click',(e) => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
    });
      console.log(e);
    })
  }); */
  const panels = Array.from(document.getElementsByClassName('w3-panel'));
  panels.forEach((element) =>  {
    element.addEventListener('click',(e) => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
    });
      console.log(e);
    })
  });
